<template>
	<div class="signup-select-field">
		<label>{{ label }}</label>
		<v-select v-bind="$attrs" v-on="$listeners" outlined>
			<template v-slot:prepend-inner>
				<div><SIcon :name="iconName"></SIcon></div>
			</template>
		</v-select>
	</div>
</template>

<script>
export default {
	name: 'SignupSelectField',
	props: {
		label: { type: String },
		iconName: { type: String },
	},
};
</script>

<style scoped lang="scss">
.signup-select-field {
	text-align: left;

	label {
		font-size: 12px;
		margin: 6px 0 4px 0;
		color: var(--primary-font-color);
	}

	::v-deep .v-input {
		.v-input__slot {
			min-height: 45px;
			background-color: #ffffff;
		}
		fieldset {
			border-color: var(--border-color);
			transition: 0.3s;
		}

		&:hover fieldset {
			border-color: var(--border-color-hover);
			transition: 0.3s;
		}

		&.error--text fieldset {
			border-color: #ff5252 !important;
			color: #ff5252 !important;
			caret-color: #ff5252 !important;
			transition: 0.3s;
		}

		.v-input__prepend-inner {
			margin-top: 17px;
		}
		.v-input__append-inner {
			margin-top: 12px !important;
		}

		svg {
			transform: scale(1.3);
			margin: -3px 10px 0 4px;
		}
	}
}
</style>
